// Utilitaires de précision (échelle 2 décimales) pour éviter les artefacts binaires JS
// Toutes les valeurs internes sont manipulées en "centièmes" (entiers) puis converties à l'affichage.

export const toCents = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(n)) return 0;
  return Math.round((n + Number.EPSILON) * 100);
};

export const fromCents = (cents) => (cents / 100);

export const formatCents = (cents) => {
  return (cents / 100).toFixed(2);
};

// Conversion Or fin -> 750 équivalent: diviser par 0.75 puis passer en centièmes.
export const orFinTo750Cents = (val) => {
  if (val === null || val === undefined || val === '') return 0;
  const n = typeof val === 'number' ? val : parseFloat(val);
  if (isNaN(n)) return 0;
  return Math.round(((n / 0.75) + Number.EPSILON) * 100);
};

// Pourcentage (perte) appliqué à une base en centièmes => résultat en centièmes.
export const percentOfCents = (baseCents, pct) => {
  if (!baseCents || !pct) return 0;
  const p = typeof pct === 'number' ? pct : parseFloat(pct);
  if (isNaN(p)) return 0;
  return Math.round(baseCents * p / 100);
};

// Addition sécurisée (juste pour sémantique)
export const addCents = (...vals) => vals.reduce((acc, v) => acc + (v || 0), 0);
